export const createCheckoutSlice = (set) => ({
  checkout_step: 1,
  shipping_address: null,
  shipping_method: 'standard',
  billing_address: null,
  use_shipping_as_billing: true,
  buyNowItem: null,

  setCheckoutStep: (step) => set({ checkout_step: step }),
  setShippingAddress: (address) => set({ shipping_address: address }),
  setShippingMethod: (method) => set({ shipping_method: method }),
  setBillingAddress: (address) => set({ billing_address: address }),
  setUseShippingAsBilling: (use) => set({ use_shipping_as_billing: use }),
  setBuyNowItem: (item) => set({ buyNowItem: item }),
  clearBuyNowItem: () => set({ buyNowItem: null }),

  resetCheckout: () => set({
    checkout_step: 1,
    shipping_address: null,
    shipping_method: 'standard',
    billing_address: null,
    use_shipping_as_billing: true,
    buyNowItem: null,
  }),
});
